var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8256 11.7677L18.8122 10.781C19.3329 10.2603 20.1771 10.2603 20.6979 10.781L21.6407 11.7238C22.1613 12.2445 22.1613 13.0888 21.6407 13.6095L20.654 14.5961M17.8256 11.7677L11.4151 18.1781C11.1937 18.3995 11.0573 18.6917 11.0298 19.0036L10.8684 20.8306C10.8319 21.2439 11.1778 21.5898 11.5911 21.5533L13.4181 21.3919C13.7299 21.3644 14.0222 21.2279 14.2435 21.0066L20.654 14.5961M17.8256 11.7677L20.654 14.5961",
    stroke: "#4C4C4C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.ccda3dc210266e145d4c343dad40d33c.svg";
export { ForwardRef as ReactComponent };